import { render, staticRenderFns } from "./OLoginHeader.vue?vue&type=template&id=6e3a2582&scoped=true&"
import script from "./OLoginHeader.vue?vue&type=script&lang=ts&"
export * from "./OLoginHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3a2582",
  null
  
)

export default component.exports